module.exports = __webpack_public_path__ + "static/img/pt.69b9e41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/pt.png
// module id = HRTV
// module chunks = 18